export const GTM_KEY = 'GTM-PSN6HSR'
export const UA_KEY = 'UA-121945988-5'
